// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CourseGrid_wrapper___SxWL","skeleton-loading":"CourseGrid_skeleton-loading__HojD_"};